import { createReducer, on } from '@ngrx/store';
import { CohortTypeEnum } from 'src/portal/buyerscaddy-api/models/cohort-type-enum';
import { InsightBucketEnum } from 'src/portal/buyerscaddy-api/models/insight-bucket-enum';
import { InsightDto } from 'src/portal/buyerscaddy-api/models/insight-dto';
import { InsightIdEnum } from 'src/portal/buyerscaddy-api/models/insight-id-enum';
import { TechStackDto } from 'src/portal/buyerscaddy-api/models/tech-stack-dto';
import * as TechStackActions from './insight.actions';

export interface TechStackState {
  loading: boolean;
  insights: { [key: string]: InsightDto[] };
  error: any;
}

const initialState: TechStackState = {
  loading: false,
  insights: {},
  error: null,
};

export const techStackInsightReducer = createReducer(
  initialState,
  on(TechStackActions.loadTechStackInsights, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(TechStackActions.loadTechStackInsightsSuccess, (state, { params, insights }) => {
    return {
      ...state,
      loading: false,
      insights: {
        ...state.insights,
        [getCacheKey(params)]: insights,
      },
    };
  }),
  on(TechStackActions.loadTechStackInsightsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);

function getCacheKey(params: { cohort: CohortTypeEnum; bucket: InsightBucketEnum[],insightIdEnum: InsightIdEnum[],body?: TechStackDto }): string {
  return JSON.stringify(params);
}
